import React, { useEffect } from "react";
import { Container } from "react-bootstrap";

const Home = () => {
  useEffect(() => {
    document.title = "Campaign Mania";
  }, []);
  return (
    <Container>
      <div className="text-center display-2 font-weight-bold text-dark">
        Form
      </div>
    </Container>
  );
};

export default Home;
